import { Component, OnInit ,Input} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { AppComponentClass } from '../../service/AppComponent.class';
import { MortgageService } from '../mortgage.service';
import { Scripts, FormScripts } from '../../../dialer/model/model.mortgage';

@Component({
  selector: 'app-script',
  templateUrl: './script.component.html',
  styleUrls: ['./script.component.css']
})
export class ScriptComponent extends AppComponentClass<Scripts, FormScripts>  {
  private __data = new BehaviorSubject<Scripts>(null);
  public solution= this.__data.asObservable();  
  public curscript:any;
  form : FormGroup;

  constructor(public data: MortgageService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar)
  {
    super(data, router, fb , msg); 
  }
  @Input() set scriptdata(v : Scripts) {
    this.debug_log("Setting current data for script to "+v);
    this.__data.next(v);
  }

  ngOnInit() {
    this.solution.subscribe(res=>{
      if(res !=null)
      {
        this.cdata=new FormScripts(res);
        console.log("Current on script ts "+this.cdata.id);
        console.log(this.cdata);
        this.form=this.makeform(this.fb);
        //this.curscript=res.script_body;    
      }
      else
      {
        console.log("NUll Script has been called");
        this.cdata=new FormScripts(res);
        this.form=this.makeform(this.fb);
       // this.curscript=null; 
      } 
    });
  }

  makeform(fb:FormBuilder):FormGroup
  {
    return fb.group({
      script_body      : [this.cdata.script_body]
    });
  }
}



